export default __webpack_public_path__ + "atomic/_patterns/03-organisms/related-content-block/_related-content-block.twig";